<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 2C6.47976 2 1.99976 6.48 1.99976 12C1.99976 17.52 6.47976 22 11.9998 22C17.5198 22 21.9998 17.52 21.9998 12C21.9998 6.48 17.5198 2 11.9998 2ZM11.9998 20C7.58976 20 3.99976 16.41 3.99976 12C3.99976 7.59 7.58976 4 11.9998 4C16.4098 4 19.9998 7.59 19.9998 12C19.9998 16.41 16.4098 20 11.9998 20ZM15.8798 8.29L9.99976 14.17L8.11976 12.29C7.72976 11.9 7.09976 11.9 6.70976 12.29C6.31976 12.68 6.31976 13.31 6.70976 13.7L9.29976 16.29C9.68976 16.68 10.3198 16.68 10.7098 16.29L17.2998 9.7C17.6898 9.31 17.6898 8.68 17.2998 8.29C16.9098 7.9 16.2698 7.9 15.8798 8.29Z"
      fill="#00BE8B"
    />
  </svg>
</template>
